/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2021 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

export default class ObservableEvent<T> extends cc.Event.EventCustom
{
    public detail: T;

    protected rootValueChanged: boolean = false;
    public get RootValueChanged(): boolean { return this.rootValueChanged; }

    constructor(type: string, bubbles: boolean, options: IObservableEventOptions<T> = null)
    {
        super(type, bubbles);

        if (!options) { return; }
        if (options.Detail != null) { this.detail = options.Detail; }
        if (options.RootvalueChanged === true) { this.rootValueChanged = true; }
    }
}

interface IObservableEventOptions<T>
{
    Detail?: T;
    RootvalueChanged: boolean;
}
